'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTheme = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactMethods = require('hoist-non-react-methods');

var _hoistNonReactMethods2 = _interopRequireDefault(_hoistNonReactMethods);

var _theme = require('../theme');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CHANNEL = '__styled-components__';

var contextTypes = _defineProperty({}, CHANNEL, _propTypes2.default.func);

function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && Component.prototype.isReactComponent);
}

var withTheme = exports.withTheme = function withTheme(WrappedComponent) {
  var isStatefull = isClassComponent(WrappedComponent);

  var WithTheme = function (_Component) {
    _inherits(WithTheme, _Component);

    function WithTheme(props) {
      _classCallCheck(this, WithTheme);

      var _this = _possibleConstructorReturn(this, (WithTheme.__proto__ || Object.getPrototypeOf(WithTheme)).call(this, props));

      _this.state = {
        theme: {}
      };
      _this._unsubscribe = null;
      return _this;
    }

    _createClass(WithTheme, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        if (this.context[CHANNEL]) {
          var subscribe = this.context[CHANNEL];
          this._unsubscribe = subscribe(function (theme) {
            _this2.setState({
              theme: theme
            });
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this._unsubscribe) this._unsubscribe();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var theme = (0, _theme.extractThemeOrDefault)(this.state.theme);

        var props = _extends({}, this.props, {
          theme: theme
        });

        if (isStatefull) props.ref = function (ref) {
          _this3.wrappedComponent = ref;
        };
        return _react2.default.createElement(WrappedComponent, props);
      }
    }]);

    return WithTheme;
  }(_react.Component);

  WithTheme.contextTypes = contextTypes;
  WithTheme.displayName = 'WithTheme(' + WrappedComponent.displayName + ')';
  WithTheme.propTypes = _extends({}, WrappedComponent.propTypes, {
    theme: _propTypes2.default.object
  });
  WithTheme.defaultProps = _extends({}, WrappedComponent.defaultProps);
  return isStatefull ? (0, _hoistNonReactMethods2.default)(WithTheme, WrappedComponent, function (c) {
    return c.wrappedComponent;
  }) : WithTheme;
};